import type { CostOverrideMode } from "@repo/shared/types";
import { Badge } from "@/components/ui/badge";
import { useT } from "@/lib/i18n/use-t";
import { T } from "./advisor-override-badge.i18n";

/** QL-20 — marks a fee advisors may override; nothing when overrides are off. */
export function AdvisorOverrideBadge({ mode }: { mode: CostOverrideMode | undefined }) {
  const t = useT(T);
  if (!mode || mode === "off") return null;
  return (
    <Badge variant="outline" className="ml-2 text-xs font-normal">
      {mode === "note_required" ? t.noteRequired : t.allowed}
    </Badge>
  );
}
